import { useInfiniteQuery } from '@tanstack/react-query';
import { baseQueryKeys, PagingListReturnModel } from '@cksoftware/react-base';
import { PaginationQueryParams } from '../../../constants/apiRoutes/paginationQueryParams';
import { ApiRoute } from '../../../constants/apiRoutes/apiRoute';

const fetchItems = async <T>(
  route: ApiRoute<PaginationQueryParams>,
  params: PaginationQueryParams
): Promise<PagingListReturnModel<T>> => {
  const axiosInstance = window.getAxios();
  const url = route.build(params);
  const response = await axiosInstance.get<PagingListReturnModel<T>>(url);
  return response.data;
};

export function useGenericCrudInfiniteListQuery<T>(
  route: ApiRoute<PaginationQueryParams>,
  queryParameters: PaginationQueryParams
) {
  return useInfiniteQuery({
    queryKey: [...baseQueryKeys.genericCrudList(route.path), { ...queryParameters }],
    queryFn: async ({ pageParam = 0 }: { pageParam?: number }) =>
      fetchItems<T>(route, { ...queryParameters, page: pageParam }),
    initialPageParam: 0,
    getNextPageParam: (lastPage, _allPages, lastPageParam) => {
      if (lastPage.PagedRows.length === 0) {
        return undefined;
      }
      return lastPageParam + 1;
    },
    getPreviousPageParam: (_firstPage, _allPages, firstPageParam) => {
      if (firstPageParam <= 1) {
        return undefined;
      }
      return firstPageParam - 1;
    }
  });
}
